<template>
  <div>
    <el-col :span="24" class="box-first box-menu container">
      <div class="pa--2">
        <Skeleton :loading="isLoading(isUndefined(menuDetail.imageUrl))">
          <template #loading>
            <div class="image color-lightgray"/>
          </template>
          <template>
            <el-image
              v-if="menuDetail.imageUrl && menuDetail.imageUrl !== noImagePath"
              class="image"
              :src="'https://images.foodstory.co/' + menuDetail.imageUrl"
              fit="cover"
              lazy
            />
          </template>
        </Skeleton>
       
        <div 
          class="text-left pa--2 menu-name"
          :class="{ 'no-img': menuDetail.imageUrl === noImagePath }"
        >
          <Skeleton 
            :loading="isLoading(isUndefined(menuDetail.name, menuDetail.price, menuDetail.description))" 
          >
            <template #loading>
              <div>
                <SkeletonItem variant="title2" style="width: 100%; height: 26px;" />
              </div>
              <div>
                <SkeletonItem variant="title2" style="width: 50%; height: 26px;" />
              </div>
              <div>
                <SkeletonItem variant="title2" style="width: 20%; height: 26px;" />
              </div>
              <div>
                <SkeletonItem variant="body" style="width: 70%;" />
              </div>
            </template>
            <template>
              <span class="menu-title fw-lg">{{ menuDetail.name }}</span>
              <div class="bottom clearfix">
                <span class="menu-price">
                  <em
                    v-if="menuDetail.optionGroups && menuDetail.optionGroups.length" 
                    class="text-heading3--med fs-st-n"
                  >
                    {{ $t('pageMenuDetail.start') }}
                  </em> 
                  {{ price_format(menuDetail.price,$store.getters.currency) }}
                </span><br>
                <span class="menu-description">{{ menuDetail.description }}</span>
              </div>
            </template>
          </Skeleton>
        </div>
      </div>
    </el-col>
  </div>
</template>

<script>
import Mixins from '@/utils/mixins'

  export default {
    name: 'MenuDetailHeader',
	  mixins: [Mixins],
    props: {
      menuDetail: {
        default: () => ({})
      },
      loading: {
        default: false
      }
    },
    data: function() {
      return { noImagePath: 'restaurant/add_menu_edit_no_image.png' }
    },
    methods: {
      isLoading: function(condition) {
        return condition && this.loading
      },
      isUndefined: function(...values) {
        return values.every(value => value === undefined)
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/menudetail/MenuDetailHeader.vue